import React from "react";
import { ArrowUpRight } from "lucide-react";

export default function Services({ t }) {
  return (
    <section id="services" data-testid="services-section" className="relative bg-ink border-t border-line py-24 md:py-36">
      <div className="px-6 md:px-12 lg:px-20">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16 mb-16 md:mb-24">
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-6">
              <span className="block h-px w-10 bg-leaf"></span>
              <p className="text-[11px] tracking-[0.4em] uppercase text-ash">{t.services.eyebrow}</p>
            </div>
            <h2
              data-testid="services-title"
              className="font-serif font-light text-bone text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight"
            >
              {t.services.title}
              <br />
              <span className="italic">{t.services.title2}</span>
            </h2>
          </div>
          <div className="md:col-span-6 md:col-start-7 self-end">
            <p className="text-ash text-base leading-relaxed max-w-md">
              {t.services.cta} — <span className="text-bone">contact@fight-lens.fr</span>
            </p>
          </div>
        </div>

        <div className="border-t border-line">
          {t.services.items.map((s, i) => (
            <article
              key={s.n}
              data-testid={`service-item-${s.n}`}
              className="group grid grid-cols-12 gap-6 md:gap-10 items-start border-b border-line py-8 md:py-12 hover:bg-surface/40 transition-colors duration-700 cursor-default"
            >
              <div className="col-span-2 md:col-span-1">
                <span className="font-display text-2xl md:text-3xl text-leaf group-hover:text-bone transition-colors">
                  {s.n}
                </span>
              </div>
              <h3 className="col-span-10 md:col-span-5 font-serif text-2xl md:text-4xl text-bone leading-tight">
                {s.t}
              </h3>
              <p className="col-span-12 md:col-span-5 text-ash text-sm md:text-base leading-relaxed">
                {s.d}
              </p>
              <div className="hidden md:flex col-span-1 justify-end items-start pt-2">
                <ArrowUpRight
                  size={22}
                  strokeWidth={1.2}
                  className="text-bone/40 group-hover:text-leaf group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-500"
                />
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
